export const siteMeta = {
  brand: "Kannur Surf Club",
  siteUrl: "https://kannursurfclub.in",
  defaultTitle: "Kannur Surf Club | Kerala Surf, Stay & Sunrise Sessions",
  defaultDescription:
    "Kannur Surf Club — Kerala's coastal surf, kite, paddle, stay, and community club. Beginner-friendly mellow waves, safe instructors, and curated stays in Kannur.",
  defaultOgImage: "https://kannursurfclub.in/assets/og-image.jpg",
  keywords: [
    "Kannur Surf Club",
    "surfing Kerala",
    "surf lessons Kannur",
    "kite surfing Kerala",
    "Kannur surf school",
    "surf stay Kerala",
  ],
};

export const media = {
  logo: "/assets/kannur-logo-white-clean.png",
  heroTexture: "https://static.prod-images.emergentagent.com/jobs/79bdb8ad-38c6-41e7-a878-948b676cec16/images/f380bbf21ab5e3301977f8ba6629f456d1445954ffe2f822233ebe751f84e568.png",
  heroSurf: "/assets/hero-surf-alt.jpg",
  heroSurfGroup: "/assets/haran.png",
  heroSurfJoti: "/assets/joti.jpg",
  heroSurfPrev: "https://images.pexels.com/photos/5232294/pexels-photo-5232294.jpeg",
  scrollVideo: "/assets/drone-cam-h264.mp4",
  scrollVideoWebm: "/assets/drone-cam.webm",
  scrollVideoPoster: "/assets/drone-cam-poster.jpg",
  surf: "/assets/surf-lesson.jpg",
  evasHomestay: "/assets/evas-homestay.jpg",
  beachEvents: "/assets/beach-events.jpg",
  kitesurf: "https://images.pexels.com/photos/13195887/pexels-photo-13195887.jpeg",
  kayak: "https://images.pexels.com/photos/7753828/pexels-photo-7753828.jpeg",
  sup: "https://images.pexels.com/photos/13184877/pexels-photo-13184877.jpeg",
  room: "https://images.pexels.com/photos/5137982/pexels-photo-5137982.jpeg",
  highRiseApartment: "https://a0.muscache.com/im/pictures/e9684a72-7da5-4eef-9c6f-e1df82831097.jpg?im_w=1440",
  hostel: "https://images.pexels.com/photos/4907199/pexels-photo-4907199.jpeg",
  about: "https://images.pexels.com/photos/32324983/pexels-photo-32324983.jpeg",
};

export const navLinks = [
  { label: "Activities", path: "/activities" },
  { label: "Accommodation", path: "/accommodation" },
  { label: "About Us", path: "/about" },
  { label: "Contact Us", path: "/contact" },
];

export const activities = [
  {
    title: "Surf Lessons",
    kicker: "Mellow waves, safe coaching",
    image: media.surf,
    description: "A relaxed, beginner-friendly way to enter the ocean with mellow Kannur waves, great instructors, and a strong safety-first rhythm.",
    details: ["Beginner friendly", "Mellow wave spots", "Great safe instructors"],
  },
  {
    title: "Kite Surfing",
    kicker: "Wind, control, flight",
    image: media.kitesurf,
    description: "Wind-powered progression with clear safety guidance, kite handling, beach drills, and golden-hour sessions shaped around the right coastal conditions.",
    details: ["Wind-window training", "Safety-first setup", "Golden-hour energy"],
  },
  {
    title: "Kayaking",
    kicker: "Backwaters and coastline",
    comingSoon: true,
    image: media.kayak,
    description: "A calm-water activity planned for guests who want a softer ocean-day option around Kannur’s coast and backwaters.",
    details: ["Interest list open", "Calm-water focus", "Group friendly"],
  },
  {
    title: "SUP Rentals",
    kicker: "Balance and glide",
    comingSoon: true,
    image: media.sup,
    description: "Stand-up paddleboard rentals are being planned for relaxed explorers who want balance, glide, and scenic water time.",
    details: ["Interest list open", "Rental model", "Beginner friendly"],
  },
  {
    title: "Beach Events",
    kicker: "Wave sessions, music, and more",
    image: media.beachEvents,
    description: "We bring the surfers of Kannur together for wave sessions, music nights, and other coastal experiences shaped by the local community.",
    details: ["Wave sessions", "Music nights", "Curated experiences"],
  },
];

export const stays = [
  {
    name: "Highest Place in Kannur",
    style: "Luxury high-rise apartment",
    image: media.highRiseApartment,
    copy: "A private high-rise stay with sweeping city and coastline views — polished, quiet, and curated for surfers who want an elevated base between ocean days.",
    bookingType: "airbnb",
    bookingUrl: "https://www.airbnb.co.in/rooms/36273087",
  },
  {
    name: "Eva’s Homestay",
    style: "Warm local home stay",
    image: media.evasHomestay,
    copy: "A warm, personal homestay with home-cooked breakfast, local coastal rhythm, and a stay experience shaped by people from the surf club.",
    bookingType: "direct",
  },
  {
    name: "Surf Camp Hostel",
    style: "Social surf hostel",
    price: "Launch timeline shared on request",
    comingSoon: true,
    image: media.hostel,
    copy: "A social surf hostel is planned for travellers who want a curated club stay, shared rooms, quick lesson access, and the classic surf-camp feel.",
    bookingType: "interest",
  },
];

export const partner = {
  name: "Kite Surf India",
  role: "Sister company · adventure-sports operator",
  url: "https://kitesurfindia.in",
};

export const contact = {
  managerName: "Chinmay",
  managerRole: "Club manager",
  managerPhone: "+91 88481 34229",
  managerPhoneRaw: "+918848134229",
  managerWhatsapp: "https://wa.me/918848134229",
  ownerName: "Rajesh",
  ownerRole: "Activity operator · Kite Surf India",
  ownerPhone: "+91 99477 11004",
  ownerPhoneRaw: "+919947711004",
  ownerWhatsapp: "https://wa.me/919947711004",
  whatsapp: "https://wa.me/918848134229",
  whatsappIntents: {
    activities: "https://wa.me/918848134229?text=Hi%20Club%20Manager%2C%20I%27d%20like%20help%20choosing%20activities%20at%20Kannur%20Surf%20Club.",
    bookSession: "https://wa.me/918848134229?text=Hi%20Club%20Manager%2C%20I%27d%20like%20to%20book%20a%20session%20at%20Kannur%20Surf%20Club.",
    kiteLesson: "https://wa.me/919947711004?text=Hi%2C%20I%27d%20like%20to%20book%20a%20kite%20surfing%20lesson%20at%20Kannur%20Surf%20Club.",
    planSession: "https://wa.me/918848134229?text=Hi%20Club%20Manager%2C%20I%27d%20like%20to%20plan%20my%20session%20dates%20and%20activities.",
  },
  instagramHandle: "@kannursurfclub",
  instagramUrl: "https://www.instagram.com/kannursurfclub/",
  location: "Kannur, Kerala, India",
};
